export default "__VITE_ASSET__Ban8k$Qe__"